import { render, staticRenderFns } from "./AtaListagem.vue?vue&type=template&id=b9a49c0e&scoped=true"
import script from "./AtaListagem.vue?vue&type=script&lang=js"
export * from "./AtaListagem.vue?vue&type=script&lang=js"
import style0 from "./AtaListagem.vue?vue&type=style&index=0&id=b9a49c0e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a49c0e",
  null
  
)

export default component.exports